import { render, staticRenderFns } from "./WelcomingScreen.vue?vue&type=template&id=463ac877&scoped=true"
import script from "./WelcomingScreen.vue?vue&type=script&lang=js"
export * from "./WelcomingScreen.vue?vue&type=script&lang=js"
import style0 from "./WelcomingScreen.vue?vue&type=style&index=0&id=463ac877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ac877",
  null
  
)

export default component.exports